import gerenciamentoEnvioRepository from './gerenciamentoEnvioRepository'
import medicamentoRepository from './medicamentoRepository'
import parametrizacaoRepository from './parametrizacaoRepository'
import relatorioEnvioRepository from './relatorioEnvioRepository'

export default baseUrl => {
    return {
        gerenciamentoEnvio: gerenciamentoEnvioRepository(baseUrl),
        medicamento: medicamentoRepository(baseUrl),
        parametrizacao: parametrizacaoRepository(baseUrl),
        relatorioEnvio: relatorioEnvioRepository(baseUrl),
    }
}